import { useContext, useEffect, useRef } from 'react';
import elementSettings from 'src/js/modules/element-settings';
import combineBatches from 'src/js/modules/element-settings/helpers/combine-batches';
import useAutoPaddingSync from '../hooks/use-auto-padding-sync';
import settingIds from '../constants/setting-ids';
import buildLegacyMigrationBatch from './build-legacy-migration-batch';
import getParentColumnsElementIds from './get-parent-columns-element-ids';
import legacyAttributes from './legacy-attributes';

const { Context: ElementSettingsContext } = elementSettings;

const useMigrateLegacyAttributes = ({ enabled, columnElementIds = [], onUpdateState }) => {
  const didRunRef = useRef(false);
  const { state } = useContext(ElementSettingsContext);
  const { getAutoPaddingBatch } = useAutoPaddingSync();

  useEffect(() => {
    if (!enabled || didRunRef.current) {
      return;
    }

    const migrationBatch = buildLegacyMigrationBatch(
      {
        [settingIds.THIS_COLUMN]: columnElementIds,
        [settingIds.ALL_COLUMNS]: getParentColumnsElementIds(columnElementIds),
      },
      legacyAttributes,
      state
    );

    if (!Object.keys(migrationBatch).length) {
      didRunRef.current = true;
      return;
    }

    const batch = combineBatches([
      migrationBatch,
      getAutoPaddingBatch(migrationBatch, { elementIds: columnElementIds }),
    ]);

    didRunRef.current = true;
    onUpdateState(batch, { shouldScrollToTarget: false });
  }, [enabled, columnElementIds, state, getAutoPaddingBatch, onUpdateState]);
};

export default useMigrateLegacyAttributes;
